import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { UserDataService } from '../../data-services/user.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { UserEditComponent } from './user.edit';
import { DialogService } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
   selector: 'app-user-list',
   templateUrl: './user.list.html',
   providers: [DialogService],
   imports: [TableModule, HasClaimDirective]
})
export class UserListComponent implements OnInit {
  
  constructor(private userDataService: UserDataService,
    public dialogService: DialogService) {
   }

   users;
   statuses: SelectItem[] = [];
   totalRecords: number;
   cols: any[];
   loading: boolean;
  selectedStatus: SelectItem;
  viewref: any = null;

  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;    


   ngOnInit() {
     //var secUser = AppComponent.currentUser;
      this.cols = [
         { field: 'UserName', header: 'User' },
         { field: 'LastName', header: 'Last Name' },
         { field: 'FirstName', header: 'First Name' },
      ];
     this.loading = true;
   }

   public handleSearchKey(event, reqlist) {
      if (event.keyCode == 13) {
         reqlist.filterGlobal(event.target.value, 'contains');
         event.preventDefault();
      }
   }

   lastLoad: LazyLoadEvent;
   public loadUsersLazy(event: LazyLoadEvent) {
     this.loading = true;
     if (event) {
       this.lastLoad = event;
     } else {
       this.lastLoad.first = 0;
       event = this.lastLoad;
     }
     this.userDataService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
         this.totalRecords = data.totalRows;
         this.users = data.rows;
         this.loading = false;
      });
   }
  openUserEdit(userName) {
    var title = "";
    if (userName) {
      title = "Edit User"
    } else {
      title = "Add User"
    }
    const ref = this.dialogService.open(UserEditComponent, {
      header: title,
      data: {
        userName: userName
      },
      width: '800px',
      modal: true
    });

    ref.onClose.subscribe((pkg) => {
      this.loadUsersLazy(this.lastLoad);
    });
  }

}
